import { L10n } from "../types/l10n";

function decodeHTML(value: string): string {
  return value.replace(/&#(\d+);/g, (_match, dec) => {
    return String.fromCharCode(dec);
  });
}

export function decodeL10n(l10n: L10n): L10n {
  const decodedL10n: L10n = {
    addToCart: decodeHTML(l10n.addToCart),
    color: decodeHTML(l10n.color),
    colors: decodeHTML(l10n.colors),
    exVATAcronym: decodeHTML(l10n.exVATAcronym),
    imageMainView: decodeHTML(l10n.imageMainView),
    incVATAcronym: decodeHTML(l10n.incVATAcronym),
    more: decodeHTML(l10n.more),
    moreProducts: decodeHTML(l10n.moreProducts),
    nextArticlePage: decodeHTML(l10n.nextArticlePage),
    pageOfPages: decodeHTML(l10n.pageOfPages),
    previousArticlePage: decodeHTML(l10n.previousArticlePage),
    priceFromLocale: decodeHTML(l10n.priceFromLocale),
    takeAwayHeadline: decodeHTML(l10n.takeAwayHeadline),
    variant: decodeHTML(l10n.variant),
    variants: decodeHTML(l10n.variants),
    newLabel: decodeHTML(l10n.newLabel),
    saleLabel: decodeHTML(l10n.saleLabel),
    rrp: decodeHTML(l10n.rrp),
    setPrice: decodeHTML(l10n.setPrice),
    comparisonPrice: decodeHTML(l10n.comparisonPrice),
    colon: decodeHTML(l10n.colon)
  };
  return decodedL10n;
}
